module.exports = __webpack_public_path__ + "static/media/Robb Stark 1.249b2414.jpg";